export default __webpack_public_path__ + "static/AGaramondPro-Italic-a0eb06983eb72a9e4f0a73b4f5cc33ae.woff";